import React from "react";
import moment from "moment";
import { Group } from "@mantine/core";
import McaStatusBadge from "./McaStatusBadge";
import { McaApprovalListBadge } from "./McaEntityIndicators";
import { getEntityLabel, MCA_ENTITIES } from "../../data/mcaEntities";

const MCA_ACTION_FILTER_VALUES = [
  { label: "Create", value: "CREATE" },
  { label: "Update", value: "UPDATE" },
  { label: "Delete", value: "DELETE" },
];

const MCA_STATUS_FILTER_VALUES = [
  { label: "Draft", value: "DFT" },
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
];

const MCA_ENTITY_FILTER_VALUES = MCA_ENTITIES.map((entity) => ({
  label: entity.label,
  value: entity.value,
}));

export const mcaProcessColumns = () => [
  {
    field: "name",
    headerName: "Process Name",
    width: 220,
  },
  {
    field: "triggerConfig.targetEntity",
    headerName: "Entity",
    width: 120,
    cellRender: (col, data) => getEntityLabel(data?.triggerConfig?.targetEntity),
    filterable: true,
    filter: {
      field: "triggerConfig.targetEntity",
      label: "Entity",
      staticValues: MCA_ENTITY_FILTER_VALUES,
      width: 280,
      height: 300,
    },
  },
  {
    field: "triggerConfig.action",
    headerName: "Action",
    width: 100,
    filterable: true,
    filter: {
      field: "triggerConfig.action",
      label: "Action",
      staticValues: MCA_ACTION_FILTER_VALUES,
      width: 220,
      height: 200,
    },
  },
  {
    field: "steps",
    headerName: "Steps",
    width: 80,
    cellRender: (col, data) => data?.steps?.length ?? 0,
  },
  {
    field: "status",
    headerName: "Status",
    width: 220,
    cellRender: (col, data) => (
      <Group spacing={4} noWrap>
        <McaStatusBadge status={data?.status} />
        <McaApprovalListBadge entity={data} />
      </Group>
    ),
    filterable: true,
    filter: {
      field: "status",
      label: "Status",
      staticValues: MCA_STATUS_FILTER_VALUES,
      width: 220,
      height: 200,
    },
  },
  {
    field: "updatedAt",
    headerName: "Updated",
    width: 140,
    cellRender: (col, data) =>
      data?.updatedAt ? moment(data.updatedAt).format("YYYY-MM-DD HH:mm") : "",
  },
];

export const mcaRequestColumns = () => [
  {
    field: "code",
    headerName: "Request Code",
    width: 160,
  },
  {
    field: "targetEntity",
    headerName: "Entity",
    width: 120,
    cellRender: (col, data) => getEntityLabel(data?.targetEntity),
  },
  {
    field: "targetEntityCode",
    headerName: "Entity Code",
    width: 120,
  },
  {
    field: "action",
    headerName: "Action",
    width: 90,
  },
  {
    field: "maker",
    headerName: "Maker",
    width: 140,
    cellRender: (col, data) => data?.maker?.name ?? data?.maker?.cname ?? "",
  },
  {
    field: "currentStep",
    headerName: "Step",
    width: 80,
    cellRender: (col, data) =>
      data?.totalSteps
        ? `${(data.currentStep ?? 0) + 1}/${data.totalSteps}`
        : "",
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    cellRender: (col, data) => <McaStatusBadge status={data?.status} />,
  },
  {
    field: "createdAt",
    headerName: "Created",
    width: 140,
    cellRender: (col, data) =>
      data?.createdAt ? moment(data.createdAt).format("YYYY-MM-DD HH:mm") : "",
  },
];
